import { useState } from "react";
import VoiceCaptureButton from "./VoiceCaptureHover";
import VoiceCaptureSidebar from "./VoiceCaptureSidebar";
import type { ModificationResult } from "../model";

interface VoiceCaptureSystemProps {
  onModificationsApproved?: (modifications: ModificationResult) => void;
  projectId?: number;
}

export default function VoiceCaptureSystem({
  onModificationsApproved,
  projectId,
}: VoiceCaptureSystemProps) {
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const togglePanel = () => setIsPanelOpen((prev) => !prev);
  const closePanel = () => setIsPanelOpen(false);

  const handleModificationsApproved = (modifications: ModificationResult) => {
    // Apply modifications and close panel
    if (onModificationsApproved) {
      onModificationsApproved(modifications);
    }
    // Keep panel open so user can see the result and continue capturing
    // They can close it manually when done
  };

  return (
    <>
      {/* VS Code-style button in top right */}
      <div className="fixed top-4 right-4 z-40">
        <VoiceCaptureButton onActivate={togglePanel} isActive={isPanelOpen} />
      </div>

      {/* Bottom Panel - shown when activated */}
      <VoiceCaptureSidebar
        isOpen={isPanelOpen}
        onClose={closePanel}
        onModificationsApproved={handleModificationsApproved}
        projectId={projectId}
      />
    </>
  );
}
